/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { Widget, Widget$inboundSchema } from "./widget.js";

export type ListWidgetsResult = {
  /**
   * Widgets in the project, most recently updated first
   */
  widgets: Array<Widget>;
};

/** @internal */
export const ListWidgetsResult$inboundSchema: z.ZodMiniType<
  ListWidgetsResult,
  unknown
> = z.object({
  widgets: z.array(Widget$inboundSchema),
});

export function listWidgetsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListWidgetsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListWidgetsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListWidgetsResult' from JSON`,
  );
}
